import { render, staticRenderFns } from "./PieArticulosChartComp.vue?vue&type=template&id=a8995726&scoped=true&"
import script from "./PieArticulosChartComp.vue?vue&type=script&lang=js&"
export * from "./PieArticulosChartComp.vue?vue&type=script&lang=js&"
import style0 from "./PieArticulosChartComp.vue?vue&type=style&index=0&id=a8995726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8995726",
  null
  
)

export default component.exports